export const getBaseApiUrl = () => {
  if (window.location.pathname === "/l" || window.location.pathname === "/pl" || window.location.pathname === "/lp") {
    return process.env.REACT_APP_LITE_API_URL;
  }

  return process.env.REACT_APP_PRO_API_URL;
}